<app-main-layout>
  <app-season-directory-page></app-season-directory-page>
</app-main-layout>
